/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Note
 *
 * 2 = WaNote
 */
export enum WarrantyLogNoteType {
  Note = 1,
  WaNote = 2,
}
